import React, { useState } from 'react';
import PopUpRadioQuestions from '../PopUpRadioQuestions';
import Button from '@material-ui/core/Button';

export default function CoverageLengthPopUpContent(props) {
    const { onHide, onFieldChange } = props;
    const [coverage, setCoverage] = useState([0, 0, 0, 0]);
    const [coverageString, setCoverageString] = useState('');
    const [coverageQuestions, setCoverageQuestions] = useState({
        coverage_duration: '',
        dependents_details: '',
        income_replacement: '',
        mortgage_length: '',
    });

    const coverageOptions = (isDependent, isMortgage) => {
        let options = [];
        if (isDependent) {
            options.push({ value: 'I have no dependents (other than my spouse)', label: "I have no dependents (other than my spouse)", rating: 0 });
        }
        if (isMortgage) {
            options.push({ value: 'none', label: "none", rating: 0 });
        }

        options.push(
            { value: '1-5 year', label: "1-5 year", rating: 5 },
            { value: '6-10 years', label: "6-10 years", rating: 10 },
            { value: '11-15 years', label: "11-15 years", rating: 15 },
            { value: '16-20 years', label: "16-20 years", rating: 20 },
            { value: '21-25 years', label: "21-25 years", rating: 25 },
            { value: '26 years or more', label: "26 years or more", rating: 30 },
        )

        return options;
    }

    const setAnswer = (name = null, value = null, covValue = null) => {
        let covLength = coverage;
        if (currentStep === 5) {
            const covObj = getCoverageLengthValue(covLength);
            onFieldChange(covObj.coverageString);
            onHide();
            return;
        }
        setCoverageQuestions({ ...coverageQuestions, [name]: value })
        covLength[currentStep - 1] = covValue;
        setCoverage(covLength);

        if (currentStep === 4) {
            const covObj = getCoverageLengthValue(covLength);
            setCoverageString(covObj.fullString)
        }
        setCurrentStep(currentStep + 1)
    }

    const getCoverageLengthValue = (covVal) => {
        let finalCoverage = Math.max.apply(null, covVal.filter(Boolean));
        let coverageString = '';
        let fullString = '';

        switch (finalCoverage) {
            case 15:
            case 20:
            case 25:
            case 30:
            case 5:
            case 10:
                coverageString = `${finalCoverage}`;
                fullString = `${finalCoverage} Year Term Life`;
                break;
            case 100:
                coverageString = "Universal Life to Age 100";
                fullString = "Universal Life to Age 100";
                break;
            default:   
                break; 
        }
        return { coverageString, fullString };
    }
    
    const [showbutton, setshowbutton] = useState(true);
    const [currentStep, setCurrentStep] = useState(1);

    const startOver = () => {
        let newState = {
            coverage_duration: '',
            dependents_details: '',
            income_replacement: '',
            mortgage_length: '',
        }
        setCoverageQuestions(newState);
        setCurrentStep(1);
    }

    const onShowButon = () => {
        setshowbutton(false);
    }

    const goBack = () => {
        if (currentStep === 1) {
            setshowbutton(!showbutton)
        }
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1);
        }
    }

    const steps = [
        {
            step: 1,
            component: (
                <PopUpRadioQuestions question='I need coverage for:'
                    options={[
                        { value: 'My entire life', label: "My entire life", rating: 100 },
                        { value: 'For a fixed period of time, up to 30 years', label: "For a fixed period of time, up to 30 years", rating: 0 },
                    ]}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='coverage_duration'
                    setAnswer={setAnswer}
                    value={coverageQuestions.coverage_duration}
                    colWidth = {6}
                />
            )
        },
        {
            step: 2,
            component: (
                <PopUpRadioQuestions question='How many years until your dependents are living on their own and/or complete with college?'
                    options={coverageOptions(true, false)}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='dependents_details'
                    setAnswer={setAnswer}
                    value={coverageQuestions.dependents_details}
                    colWidth = {6}
                />
            )
        },
        {
            step: 3,
            component: (
                <PopUpRadioQuestions question='How many years would you like to provide income replacement for your spouse?'
                    options={coverageOptions(false, false)}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='income_replacement'
                    setAnswer={setAnswer}
                    value={coverageQuestions.income_replacement}
                />
            )
        },
        {
            step: 4,
            component: (
                <PopUpRadioQuestions question='How many years do you have left on your mortgage?'
                    options={coverageOptions(false, true)}
                    onStartOver={startOver}
                    onBack={goBack}
                    id='mortgage_length'
                    setAnswer={setAnswer}
                    value={coverageQuestions.mortgage_length}
                />
            )
        },
        {
            step: 5,
            component: (
                <PopUpRadioQuestions
                    question="Based on your answers, the best option for you is:"
                    onStartOver={startOver}
                    onBack={goBack}
                    setAnswer={setAnswer}
                    id='final_screen'
                    result={coverageString}
                />
            )
        }
    ]
    const currentStepObj = steps.find(s => s.step === currentStep);

    return (
        <div>
            {showbutton ? <div className='help-decide p-3' ><h4>Need help deciding?</h4>
                <p>Just answer a few simple questions.</p>
                <Button variant='contained' color='primary' onClick={onShowButon} >Get Started</Button></div> : currentStepObj.component}
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/components/Product/TermLifeInsurance/PopUps/CoverageLengthPopUp/CoverageLengthPopUpContent.js